// extracted by mini-css-extract-plugin
module.exports = {"page-not-found":"page-not-found_page-not-found__aIGb3","icon":"page-not-found_icon__whMGn","title":"page-not-found_title__20gdv"};